export default {
    codecommit: {
        que: "Repositorios Git privados y administrados dentro de AWS, con permisos por IAM y revisión de cambios mediante pull requests.",
        patron: "lineal",
        nodos: [["Desarrollador", "usuario"], ["Repositorio CodeCommit", "carpeta"], ["Pull Request", "red"], ["Rama principal", "archivo"]],
        pasos: ["El desarrollador sube sus cambios en una rama (git push).", "Abre un pull request para que otros revisen y comenten.", "Al aprobarse, el cambio se fusiona en la rama principal."],
        objetos: {
            "Repositorios": ["Repositorio Git con su historial, ramas y permisos.", 1],
            "Pull Requests": ["Propuesta de cambio con revisión y comentarios antes de fusionar.", 2],
        },
    },
    codebuild: {
        que: "Compila, prueba y empaqueta tu código en servidores temporales que se crean para cada build y se destruyen al terminar.",
        patron: "lineal",
        nodos: [["Código fuente", "carpeta"], ["Proyecto CodeBuild", "engranaje"], ["Build (contenedor)", "contenedor"], ["Artefactos y reportes", "archivo"]],
        pasos: ["Un cambio en el repositorio dispara el proyecto.", "CodeBuild levanta un entorno limpio con las herramientas indicadas.", "Ejecuta las fases del buildspec (instalar, probar, compilar) y guarda los artefactos y reportes."],
        objetos: {
            "Proyectos": ["Define origen, entorno y comandos (buildspec) del build.", 1],
            "Builds": ["Cada ejecución del proyecto con su registro y resultado.", 2],
            "Report Groups": ["Resultados de pruebas y cobertura de los builds.", 3],
        },
    },
    codedeploy: {
        que: "Automatiza el despliegue de aplicaciones a EC2, ECS, Lambda o servidores locales, con estrategias que evitan caídas y permiten volver atrás.",
        patron: "abanico",
        nodos: [["Nueva versión", "archivo"], ["CodeDeploy", "engranaje"], ["Servidor 1", "servidor"], ["Servidor 2", "servidor"], ["Servidor 3", "servidor"]],
        pasos: ["Entregas la nueva versión y el archivo de despliegue (appspec).", "CodeDeploy la instala por tandas (rolling) o en un entorno paralelo (blue/green).", "Verifica la salud; si falla, revierte automáticamente a la versión anterior."],
        objetos: {
            "Aplicaciones": ["Lo que se despliega y su plataforma de destino.", 0],
            "Deployment Groups": ["El conjunto de servidores o servicios destino y la estrategia de despliegue.", 2],
            "Despliegues": ["Cada ejecución con su avance y resultado.", 1],
        },
    },
    codepipeline: {
        que: "Línea de entrega continua: automatiza el camino del código desde el repositorio hasta producción, con etapas y aprobaciones.",
        patron: "lineal",
        nodos: [["Fuente (commit)", "carpeta"], ["Build", "engranaje"], ["Prueba / aprobación", "escudo"], ["Despliegue", "nube"]],
        pasos: ["Un cambio en el repositorio inicia la ejecución.", "La etapa de build compila y prueba.", "Tras pruebas y aprobación manual si hace falta, la etapa de despliegue publica a producción."],
        objetos: {
            "Pipelines": ["Definición de etapas y acciones, de la fuente al despliegue.", 1],
            "Ejecuciones": ["Cada vez que un cambio recorre el pipeline, con el estado de cada etapa.", 2],
        },
    },
    codeartifact: {
        que: "Repositorio privado de paquetes (npm, Maven, pip, NuGet): guarda tus librerías internas y actúa de intermediario seguro de los públicos.",
        patron: "lineal",
        nodos: [["Desarrollador", "usuario"], ["Repositorio CodeArtifact", "carpeta"], ["Repositorio público (npm, PyPI)", "globo"]],
        pasos: ["El desarrollador instala una dependencia desde CodeArtifact.", "Si el paquete no está, lo trae del repositorio público, lo guarda en caché y lo entrega, con versiones controladas."],
        objetos: {
            "Dominios": ["Agrupan repositorios y comparten almacenamiento y cifrado entre cuentas.", 1],
            "Repositorios": ["Almacén de paquetes con conexión a repositorios externos.", 1],
            "Paquetes": ["Cada librería con sus versiones.", 1],
        },
    },
    ecr: {
        que: "Registro privado de imágenes de contenedor, con escaneo de vulnerabilidades. De aquí leen ECS, EKS y Lambda.",
        patron: "lineal",
        nodos: [["CI / desarrollador", "usuario"], ["Repositorio ECR", "carpeta"], ["ECS / EKS", "contenedor"]],
        pasos: ["El pipeline construye la imagen y la sube (push) con una etiqueta de versión.", "ECS o EKS la descargan (pull) cuando necesitan lanzar contenedores."],
        objetos: {
            "Repositorios": ["Almacén de las versiones de una imagen, con escaneo y cifrado.", 1],
            "Imágenes": ["Cada versión etiquetada del contenedor.", 1],
            "Políticas de ciclo de vida": ["Borran automáticamente imágenes antiguas para controlar costos.", 1],
        },
    },
    cloud9: {
        que: "Entorno de desarrollo en el navegador: un editor y una terminal conectados a una instancia EC2 con tus herramientas.",
        patron: "lineal",
        nodos: [["Navegador", "usuario"], ["Cloud9 (IDE)", "engranaje"], ["Instancia EC2", "servidor"]],
        pasos: ["Abres el entorno desde cualquier equipo con solo un navegador.", "El IDE trabaja sobre una instancia EC2 con acceso directo a servicios de AWS, sin instalar nada local."],
        objetos: { "Entornos": ["Cada espacio de desarrollo con su instancia, editor y terminal.", 1] },
    },
    amplify: {
        que: "Publica sitios y aplicaciones web y móviles: conecta el repositorio, construye en cada cambio y despliega con CDN y HTTPS.",
        patron: "lineal",
        nodos: [["Repositorio Git", "carpeta"], ["Amplify (CI/CD)", "engranaje"], ["CDN + HTTPS", "globo"], ["Usuarios", "usuario"]],
        pasos: ["Cada push a una rama inicia un build.", "Amplify construye y publica la rama en su propia URL.", "Los usuarios acceden a través de la red de entrega de contenido."],
        objetos: {
            "Aplicaciones": ["Proyecto conectado al repositorio, con sus variables y backend.", 1],
            "Ramas": ["Cada rama puede tener su entorno y URL (pruebas, producción).", 1],
            "Dominios": ["Tu dominio propio con certificado automático.", 2],
        },
    },
    cdk: {
        que: "Infraestructura como código usando lenguajes de programación (CDK) o plantillas simplificadas para aplicaciones sin servidor (SAM).",
        patron: "lineal",
        nodos: [["Código (TypeScript, Python)", "archivo"], ["CDK / SAM", "engranaje"], ["Plantilla CloudFormation", "archivo"], ["Recursos AWS", "nube"]],
        pasos: ["Defines la infraestructura con código normal, con bucles y funciones.", "CDK o SAM lo sintetiza en una plantilla de CloudFormation.", "CloudFormation crea o actualiza los recursos."],
        objetos: {
            "Aplicaciones SAM": ["Funciones, APIs y tablas sin servidor definidas con un archivo breve.", 1],
            "Stacks CDK": ["Unidad de despliegue definida en código, equivalente a un stack.", 3],
        },
    },
};
